import { Icon, IconProps } from ".";

export function IconText(props: React.PropsWithChildren<IconProps>) {
    const { children, ...iconProps } = props;
    return (
        <>
            <Icon {...iconProps} />
            <span className="eac-icon-text">{children}</span>
        </>
    );
}
